import { AppStatusIncident } from '@src/main/modules/app_status/domain/appStatusIncident.model';
import AppStatusDetailPreview from './AppStatusDetailPreview';

const AppStatusErrorDescriptionBody = ({
  errorDescription,
  errorDescriptionImageUrl,
}: AppStatusIncident) => (
  <AppStatusDetailPreview
    value={errorDescription}
    imageUrl={errorDescriptionImageUrl}
    imageAltTranslationKey="appStatus.columns.errorDescription"
  />
);

export default AppStatusErrorDescriptionBody;
